import { PaletteOptions } from '@material-ui/core/styles/createPalette';

import { colours, legacyColours } from '@shared/theme/colours';

export const initializePalette = (config?: PaletteOptions): PaletteOptions => {
  return {
    primarySpecial: {
      light: colours.teal[100],
      main: colours.teal[500],
      dark: colours.teal[600],
    },
    primary: {
      light: legacyColours.blue.light,
      main: colours.navy[900],
      dark: legacyColours.blue.darkish,
    },
    secondary: {
      main: legacyColours.white.lightest,
      light: legacyColours.blue.main,
    },
    ...config,
  };
};
